import {
    Box,
    Button, Card, CardBody,
    CardHeader, Center, CircularProgress, Flex,
    Grid, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
    Text, Tooltip,
    useBreakpointValue, useColorModeValue
} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {FiPlay} from "react-icons/fi";
import {fetchDesignDetails, fetchProjectDetails, updateProjectStatus} from "./DesignTab/utils";
import {useParams} from "react-router-dom";

const TechCard = ({label}) => {
    const colors = {
        "PV": useColorModeValue("#8884d8", "#8884d8"),
        "BESS": useColorModeValue("#ffc658", "#ffc658"),
        "Utility": useColorModeValue("#82ca9d", "#82ca9d")
    }

    return (
        <Flex p={2} rounded={"md"} bg={colors[label]}>
            <Text>{label}</Text>
        </Flex>
    )
}

const TooltipText = (props) => (
    <Tooltip textAlign={"justify"} label={props.children} placement="auto-start" hasArrow>
        <Text noOfLines={1} {...props}>
            {props.children}
        </Text>
    </Tooltip>
)
const TechnologyList = ({technologies}) => (
    <Card rounded={30} variant={"outline"}>
        <CardHeader>
            <Text fontSize="xl">Technologies Added</Text>
        </CardHeader>
        <CardBody>
            <Flex gap={2}>
                {
                    technologies && technologies.map((technology, index) => <TechCard label={technology} key={index}/>)
                }
                {
                    (!technologies || technologies.length === 0) && <TooltipText fontSize={"2xl"}>No technologies added</TooltipText>
                }
                {/*<TechCard label={"PV"}/>*/}
                {/*<TechCard label={"BESS"}/>*/}
                {/*<TechCard label={"Utility"}/>*/}
            </Flex>

        </CardBody>
    </Card>
);

const ClientName = ({name}) => (
    <Card rounded={30} variant={"outline"}>
        <CardHeader>
            <Text fontSize="xl">Client Name</Text>
        </CardHeader>
        <CardBody>
            <TooltipText fontSize={"3xl"}>
                {/*Rivian*/}
                {name}
            </TooltipText>
        </CardBody>
    </Card>
);

const Location = ({location}) => (
    <Card rounded={30} variant={"outline"}>
        <CardHeader>
            <Text fontSize="xl">Location</Text>
        </CardHeader>
        <CardBody>
            <TooltipText fontSize={"3xl"}>
                {/*Atlanta, GA*/}
                {location}
            </TooltipText>
        </CardBody>
    </Card>
);

const ProjectProgress = ({progress}) => (
    <Card rounded={30} variant={"outline"}>
        <CardHeader>
            <Text fontSize="xl">Project Progress</Text>
        </CardHeader>
        <CardBody>
            <TooltipText fontSize={"5xl"}>
                {/*100%*/}
                {`${progress}%`}
            </TooltipText>
        </CardBody>
    </Card>
);

const UseCase = ({usecase}) => (
    <Card rounded={30} variant={"outline"}>
        <CardHeader>
            <Text fontSize="xl">Use Case</Text>
        </CardHeader>
        <CardBody>
            <TooltipText fontSize={"3xl"}>
                {/*Renewable Smoothing*/}
                {usecase}
            </TooltipText>
        </CardBody>
    </Card>
);

const SummaryTab = ({activeTab, setActiveTab}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSimulationRunning, setIsSimulationRunning] = useState(false);
    const [simulationCompleted, setSimulationCompleted] = useState(false);
    const [projectDetails, setProjectDetails] = useState({});
    const {projectId} = useParams();

    const openModal = () => {
        setIsOpen(true);
        setIsSimulationRunning(true);

        // Simulate a 3-second delay for the simulation
        setTimeout(() => {
            setIsSimulationRunning(false);
            setSimulationCompleted(true);
        }, 3000);
    };

    const runSimulation = () => {
        openModal();
        updateProjectStatus(projectId,"in_progress").then();
    }

    const closeModal = () => {
        setIsOpen(false);
        setIsSimulationRunning(false);
        setSimulationCompleted(false);
    };

    useEffect(() => {
        fetchProjectDetails(projectId).then(projectData => {
            if (projectData === null) projectData = {};
            fetchDesignDetails(projectId).then(data => {
                if (data !== null && data.hasOwnProperty("sections")) {
                    const sections = data.sections;
                    if (sections.length > 0 && sections[0].label === "Technologies" && sections[0].hasOwnProperty("items")) {
                        const techLabels = sections[0].items.filter(item => item.hasOwnProperty("isAdded") && item.isAdded).map(item => item.label);
                        return {...projectData, technologies: techLabels};
                    }
                }
                return {...projectData, technologies: []};
            }).then(data => {
                setProjectDetails(data);
            });
        });


    }, [activeTab]);

    return (
        <Box position="relative" height="100%" minW={"100%"}>
            <Box p={6}>
                <Grid templateColumns={"repeat(auto-fill, minmax(300px, 1fr))"} gap={6} mt={6}>
                    <TechnologyList technologies={projectDetails?.technologies}/>
                    <ClientName name={projectDetails?.name}/>
                    <Location location={projectDetails?.location}/>
                    <ProjectProgress progress={projectDetails?.progress}/>
                    <UseCase usecase={projectDetails?.usecase}/>
                </Grid>
            </Box>

            <Button
                position="absolute"
                right={4}
                bottom={4}
                rightIcon={<FiPlay/>}
                colorScheme="green"
                // onClick={()=>setActiveTab(2)}
                onClick={runSimulation}
            >
                Run Simulation
            </Button>

            <Modal isOpen={isOpen} onClose={closeModal} size="md">
                <ModalOverlay/>
                <ModalContent maxW="400px" maxH="300px">
                    <ModalHeader>Running Simulation</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        {isSimulationRunning && (
                            <Center height="150px">
                                <CircularProgress isIndeterminate color="blue.500" size="80px"/>
                            </Center>
                        )}
                        {simulationCompleted && (
                            <Text mb={4} textAlign="center">
                                Simulation completed successfully!
                            </Text>
                        )}
                    </ModalBody>
                    {simulationCompleted && (
                        <ModalFooter>
                            <Button colorScheme="teal" onClick={() => {
                                setActiveTab(2);
                                closeModal();
                            }} ml="auto">View Results</Button>
                        </ModalFooter>
                    )}
                </ModalContent>
            </Modal>
        </Box>
    )
}

export default SummaryTab;